//
// TransportModelReference.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "@sas-dvr/ltjs-commons/models/particles/Link";

var TransportModelReference = createModule("transport::TransportModelReference", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        addedDatetime: 9,
        added: 7,
        name: 7,
        isReference: 2,
        model: 1,
        links: [1],
        id: 7,
    },
    ,
    ,
    {
        addedUpdated: [0,1],
    },
    {
        _create_v: [4],
    },
    ,
    ["_create"]
]);
export default TransportModelReference;
